// 静漫天堂漫画 - 首页模拟数据
// 注意：本文件仅用于未连接后端时的展示占位，接入真实图源后请替换数据源。

export const navLinks = [
  { label: "首页", href: "#home" },
  { label: "画质精选", href: "#quality" },
  { label: "图源推荐", href: "#sources" },
  { label: "新作速递", href: "#new" },
  { label: "关于我们", href: "#about" },
  { label: "常见问题", href: "#faq" },
];

export const categories = ["全部", "热血", "古风", "奇幻", "都市", "悬疑", "治愈"];

export interface Artwork {
  id: number;
  title: string;
  category: string;
  quality: string;
  likes: number;
  views: number;
  size: string;
  image: string;
}

export const artworks: Artwork[] = [
  {
    id: 1,
    title: "暮色剑客·静谧之章",
    category: "古风",
    quality: "4K超清原图",
    likes: 3286,
    views: 12700,
    size: "3840×2160",
    image: "https://readdy.ai/api/search-image?query=warm%20toned%20stylized%20chinese%20ink%20comic%20illustration%20of%20a%20lone%20swordsman%20under%20amber%20sunset%20with%20dynamic%20brush%20strokes%20and%20paper%20texture%2C%20muted%20earth%20palette%2C%20high%20detail%20artwork&width=800&height=600&seq=jm-a1&orientation=landscape",
  },
  {
    id: 2,
    title: "焰行都市·霓虹追击",
    category: "都市",
    quality: "4K超清原图",
    likes: 4219,
    views: 18450,
    size: "3840×2160",
    image: "https://readdy.ai/api/search-image?query=stylized%20urban%20comic%20art%20of%20a%20hooded%20rider%20chasing%20through%20neon%20city%20streets%20at%20dusk%20with%20warm%20orange%20and%20crimson%20lighting%2C%20dynamic%20action%2C%20ink%20and%20digital%20paint%20blend%2C%20detailed&width=800&height=600&seq=jm-a2&orientation=landscape",
  },
  {
    id: 3,
    title: "云海幻境·青空之下",
    category: "奇幻",
    quality: "4K超清原图",
    likes: 2965,
    views: 10320,
    size: "3840×2160",
    image: "https://readdy.ai/api/search-image?query=ethereal%20fantasy%20comic%20scene%20of%20floating%20islands%20above%20a%20sea%20of%20clouds%2C%20warm%20golden%20light%20breaking%20through%2C%20young%20hero%20flying%20on%20a%20paper%20crane%2C%20soft%20brushwork%2C%20whimsical%20and%20detailed&width=800&height=600&seq=jm-a3&orientation=landscape",
  },
  {
    id: 4,
    title: "暗夜谜案·灯下微光",
    category: "悬疑",
    quality: "超清原图",
    likes: 2143,
    views: 7680,
    size: "2560×1440",
    image: "https://readdy.ai/api/search-image?query=moody%20mystery%20comic%20illustration%20of%20a%20detective%20desk%20lit%20by%20a%20single%20warm%20lamp%20in%20a%20dim%20room%2C%20shadows%20and%20clues%20scattered%2C%20crimson%20and%20amber%20tones%2C%20high%20contrast%20ink%20style&width=800&height=600&seq=jm-a4&orientation=landscape",
  },
  {
    id: 5,
    title: "暖光治愈·街角猫咖",
    category: "治愈",
    quality: "原图典藏",
    likes: 5120,
    views: 22900,
    size: "4096×2732",
    image: "https://readdy.ai/api/search-image?query=cozy%20warm%20comic%20art%20of%20a%20sunlit%20cat%20cafe%20corner%20with%20soft%20afternoon%20light%2C%20a%20girl%20reading%20while%20cats%20nap%2C%20pastel%20warm%20palette%2C%20gentle%20brushwork%2C%20soothing%20and%20detailed&width=800&height=600&seq=jm-a5&orientation=landscape",
  },
  {
    id: 6,
    title: "赤焰燃魂·热血对峙",
    category: "热血",
    quality: "4K超清原图",
    likes: 4830,
    views: 20560,
    size: "3840×2160",
    image: "https://readdy.ai/api/search-image?query=energetic%20shounen%20comic%20panel%20of%20two%20fighters%20clashing%20in%20mid%20air%20with%20fiery%20crimson%20aura%2C%20dynamic%20speed%20lines%2C%20warm%20explosive%20colors%2C%20bold%20ink%20outlines%2C%20dramatic%20action&width=800&height=600&seq=jm-a6&orientation=landscape",
  },
  {
    id: 7,
    title: "暮秋书院·笔墨拾遗",
    category: "古风",
    quality: "超清原图",
    likes: 1877,
    views: 6120,
    size: "2560×1440",
    image: "https://readdy.ai/api/search-image?query=warm%20traditional%20chinese%20comic%20art%20of%20a%20lakeside%20academy%20in%20autumn%20with%20maple%20leaves%20and%20scholars%20reading%2C%20ink%20wash%20with%20amber%20highlights%2C%20serene%20and%20refined&width=800&height=600&seq=jm-a7&orientation=landscape",
  },
  {
    id: 8,
    title: "机械之心·废土黎明",
    category: "奇幻",
    quality: "原图典藏",
    likes: 3322,
    views: 14980,
    size: "4096×2732",
    image: "https://readdy.ai/api/search-image?query=post%20apocalyptic%20comic%20art%20of%20a%20young%20robot%20and%20companion%20walking%20toward%20a%20warm%20sunrise%20over%20ruins%2C%20golden%20and%20rust%20tones%2C%20hopeful%20mood%2C%20detailed%20mechanical%20design&width=800&height=600&seq=jm-a8&orientation=landscape",
  },
  {
    id: 9,
    title: "盛夏蝉鸣·青春回响",
    category: "治愈",
    quality: "4K超清原图",
    likes: 3988,
    views: 17300,
    size: "3840×2160",
    image: "https://readdy.ai/api/search-image?query=youth%20slice%20of%20life%20comic%20illustration%20of%20friends%20riding%20bicycles%20through%20a%20summer%20countryside%20with%20warm%20golden%20sunlight%2C%20cicada%20season%2C%20nostalgic%20warm%20palette%2C%20soft%20detail&width=800&height=600&seq=jm-a9&orientation=landscape",
  },
  {
    id: 10,
    title: "深海秘航·珊瑚回廊",
    category: "奇幻",
    quality: "超清原图",
    likes: 2560,
    views: 9440,
    size: "2560×1440",
    image: "https://readdy.ai/api/search-image?query=underwater%20fantasy%20comic%20scene%20of%20a%20diver%20swimming%20through%20a%20glowing%20coral%20corridor%2C%20warm%20bioluminescent%20light%2C%20teal%20and%20amber%20blend%2C%20detailed%20marine%20creatures%2C%20artistic&width=800&height=600&seq=jm-a10&orientation=landscape",
  },
  {
    id: 11,
    title: "夜行列车·归途之人",
    category: "都市",
    quality: "原图典藏",
    likes: 2904,
    views: 11080,
    size: "4096×2732",
    image: "https://readdy.ai/api/search-image?query=moody%20comic%20art%20of%20a%20night%20train%20window%20with%20a%20passenger%20gazing%20out%20at%20warm%20city%20lights%20streaking%20by%2C%20crimson%20and%20gold%20reflections%2C%20cinematic%20atmosphere%2C%20detailed&width=800&height=600&seq=jm-a11&orientation=landscape",
  },
  {
    id: 12,
    title: "风雪渡口·孤灯明灭",
    category: "古风",
    quality: "4K超清原图",
    likes: 2218,
    views: 8310,
    size: "3840×2160",
    image: "https://readdy.ai/api/search-image?query=lonely%20ferry%20at%20a%20snowy%20river%20crossing%20lit%20by%20a%20single%20warm%20lantern%2C%20traditional%20chinese%20comic%20style%2C%20cold%20blue%20snow%20with%20amber%20warm%20light%20contrast%2C%20poetic%20and%20detailed&width=800&height=600&seq=jm-a12&orientation=landscape",
  },
];

export interface Source {
  id: number;
  title: string;
  type: string;
  tags: string[];
  desc: string;
  hot: boolean;
  color: string;
}

export const sources: Source[] = [
  {
    id: 1,
    title: "静漫·典藏图库",
    type: "原图仓库",
    tags: ["4K原图", "无损格式", "持续更新"],
    desc: "汇聚经典长篇与殿堂级作品的高清原图，画质纯净，适合收藏与放大浏览。",
    hot: true,
    color: "primary",
  },
  {
    id: 2,
    title: "静漫·分镜画廊",
    type: "分镜图源",
    tags: ["对白完整", "连载同步", "排版清爽"],
    desc: "按连载节奏整理的分镜静态图源，对话与画面完整，阅读体验贴近原作。",
    hot: true,
    color: "accent",
  },
  {
    id: 3,
    title: "静漫·精修典藏",
    type: "精修图源",
    tags: ["去噪增强", "色彩校正", "细节锐化"],
    desc: "针对旧作与模糊图源做色彩校正与细节增强，让经典画面焕发新生。",
    hot: false,
    color: "secondary",
  },
  {
    id: 4,
    title: "静漫·新作前线",
    type: "新作图源",
    tags: ["实时上新", "抢先体验", "画质优先"],
    desc: "第一时间收录热门新作的静态图源页面，画质筛选后统一入库，快速查找。",
    hot: true,
    color: "primary",
  },
];

export interface Release {
  id: number;
  title: string;
  episode: string;
  date: string;
  image: string;
}

export const releases: Release[] = [
  {
    id: 1,
    title: "暮色剑客",
    episode: "第 127 话",
    date: "08-18 更新",
    image: "https://readdy.ai/api/search-image?query=vertical%20comic%20cover%20of%20a%20young%20swordsman%20in%20amber%20twilight%20holding%20a%20glowing%20blade%2C%20warm%20crimson%20and%20gold%20ink%20style%2C%20dramatic%20portrait%20composition%2C%20detailed%20artwork&width=600&height=800&seq=jm-r1&orientation=portrait",
  },
  {
    id: 2,
    title: "焰行都市",
    episode: "第 84 话",
    date: "08-18 更新",
    image: "https://readdy.ai/api/search-image?query=vertical%20comic%20cover%20of%20a%20determined%20urban%20hero%20standing%20before%20a%20warm%20neon%20cityscape%20at%20night%2C%20crimson%20highlights%2C%20dynamic%20pose%2C%20bold%20ink%20outlines%2C%20high%20detail&width=600&height=800&seq=jm-r2&orientation=portrait",
  },
  {
    id: 3,
    title: "云海幻境",
    episode: "第 210 话",
    date: "08-17 更新",
    image: "https://readdy.ai/api/search-image?query=vertical%20fantasy%20comic%20cover%20of%20a%20heroine%20riding%20a%20giant%20crane%20above%20cloud%20sea%2C%20warm%20golden%20sunset%20backlight%2C%20whimsical%20ethereal%20style%2C%20detailed%20fabric%20and%20feathers&width=600&height=800&seq=jm-r3&orientation=portrait",
  },
  {
    id: 4,
    title: "暖光治愈",
    episode: "第 46 话",
    date: "08-16 更新",
    image: "https://readdy.ai/api/search-image?query=vertical%20healing%20comic%20cover%20of%20a%20girl%20cuddling%20a%20cat%20in%20soft%20warm%20sunlight%20by%20a%20window%2C%20pastel%20warm%20tones%2C%20gentle%20cozy%20mood%2C%20soft%20brushwork%2C%20detailed&width=600&height=800&seq=jm-r4&orientation=portrait",
  },
  {
    id: 5,
    title: "暗夜谜案",
    episode: "第 158 话",
    date: "08-15 更新",
    image: "https://readdy.ai/api/search-image?query=vertical%20mystery%20comic%20cover%20of%20a%20detective%20silhouette%20against%20a%20warm%20lamp%20glow%20in%20the%20dark%2C%20crimson%20and%20black%20contrast%2C%20suspenseful%20atmosphere%2C%20detailed%20ink%20work&width=600&height=800&seq=jm-r5&orientation=portrait",
  },
  {
    id: 6,
    title: "机械之心",
    episode: "第 92 话",
    date: "08-14 更新",
    image: "https://readdy.ai/api/search-image?query=vertical%20sci%20fi%20comic%20cover%20of%20a%20small%20robot%20and%20its%20friend%20facing%20a%20warm%20rising%20sun%20over%20ruins%2C%20rust%20and%20gold%20tones%2C%20hopeful%2C%20detailed%20mechanical%20design&width=600&height=800&seq=jm-r6&orientation=portrait",
  },
];

export interface Testimonial {
  id: number;
  name: string;
  role: string;
  quote: string;
  score: number;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "夜风",
    role: "漫画收藏爱好者",
    quote: "静漫天堂的画质筛选做得太细致了，4K原图放大看线条依旧清晰，是收藏党很难找到的资源库。",
    score: 5,
  },
  {
    id: 2,
    name: "青柠",
    role: "每日追更读者",
    quote: "分类和标签很合理，新作上线速度快，分镜图源排版清爽，追更体验比想象中顺滑很多。",
    score: 5,
  },
  {
    id: 3,
    name: "南岛",
    role: "插画创作者",
    quote: "精修典藏对旧作做了很好的去噪和色彩校正，用作参考图源非常合适，细节保留完整。",
    score: 5,
  },
];

export interface Faq {
  id: number;
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    id: 1,
    q: "静漫天堂的图源都是高清原图吗？",
    a: "是的。静漫天堂对入库内容按画质严格分级，覆盖 4K超清、超清与高清原图等多个档位，并支持按画质精细筛选，帮助你在不同设备上都获得清晰的静态漫画阅读体验。",
  },
  {
    id: 2,
    q: "如何按画质快速找到想要的漫画图源？",
    a: "你可以在首页「画质精选」栏目使用分类与画质标签切换，也可以借助搜索框输入作品名或关键词，系统会结合画质档位与热度为你筛选出最合适的静态图源页面。",
  },
  {
    id: 3,
    q: "分镜图源和原图有什么区别？",
    a: "分镜图源按连载顺序整理、对白完整，适合逐页阅读；原图则保留作品原始尺寸与细节，适合收藏与放大浏览。静漫天堂已将两者分别归档，你可按需选择。",
  },
  {
    id: 4,
    q: "新作上线的更新频率是怎样的？",
    a: "静漫天堂的「新作前线」栏目保持实时上新，热门连载通常会在更新后尽快完成画质筛选与入库，你可以在「新作速递」板块查看最新同步的章节与更新日期。",
  },
  {
    id: 5,
    q: "订阅之后能获得哪些内容推送？",
    a: "订阅后你会定期收到画质精选推荐、新作上线提醒与专题整理内容，帮助你第一时间发现值得收藏的高清静态漫画图源，不会错过任何一次更新。",
  },
];